import { DocumentType } from '../enums/DocumentType'
import { DocumentTabItem } from '../types/DocumentTabItem'

export const documentsTabs: DocumentTabItem[] = [
  {
    documentType: DocumentType.INVOICE,
    label: 'contact.detail.documents_tab.invoices',
    icon: 'fileText',
  },
  {
    documentType: DocumentType.QUOTE,
    label: 'contact.detail.documents_tab.quotes',
    icon: 'filePlusCorner',
  },
]
